<template>
  <b-col
    xs="12"
    sm="12"
    md="4"
    lg="4"
    class="bg-transparent scroll-to-me padding-left-none padding-two-bottom"
    :class="{ isHidden: !isSelected }"
  >
    <b-col cols="12" class="bg-white scroll-to-me padding-ten-all">
      <b-row>
         <b-col cols="12" md="6" lg="6">
          <p class="text-large color-orange font-weight-600">OS Detalle</p>
        </b-col>
        <b-col md="6" lg="6">
          <b-form-checkbox
             @change="resetDate"
             v-model="expressService"
             size="sm">
                <b>Express</b>   
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row class="padding-two-tb">
        <b-col cols="12">
          <label for="" class="color-dark-gray font-weight-600">
            SKU servicio
          </label>

          <b-input-group>
            <b-form-input
              :disabled="isDisabled"
              v-on:input="$emit('update:skuService', $event)"
              @keyup="searchServices()"
              :value="skuService"
              class="
                border-right-none
                bg-grey
                disable-input
                text-medium
                color-black
              "
              size="md"
            >
            </b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="padding-two-tb">
        <b-col cols="12">
          <label for="" class="color-dark-gray font-weight-600"
            >Descripción servicio
          </label>
          <b-form-input
            type="text"
            :disabled="isDisabled"
            class="text-medium bg-grey disable-input color-black"
            :value="descriptionSku"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="padding-two-tb">
        <b-col cols="12">
          <label for="" class="color-dark-gray font-weight-600">Cantidad</label>
          <b-form-input
            :disabled="isDisabled"
            v-on:input="$emit('update:quantity', formatToNumber($event))"
            type="number"
            min="1"
            :max="maxLimit"
            class="bg-grey text-medium color-black"
            :value="quantity"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="padding-two-tb">
        <b-col cols="12">
          <label for="" class="color-dark-gray font-weight-600">
            SKU producto
          </label>
          <b-input-group>
            <b-form-input
              type="text"
              :disabled="isDisabled"
              v-on:input="$emit('update:skuProduct', $event)"
              :value="skuProduct"
              @keyup="searchProducts"
              class="border-right-none bg-grey text-medium color-black"
              size="md"
            >
            </b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="padding-two-tb">
        <b-col cols="12">
          <label for="" class="color-dark-gray font-weight-600"
            >Descripción producto
          </label>
          <b-form-input
            type="text"
            :disabled="isDisabled"
            class="bg-grey text-medium disable-input color-black"
            :value="descriptionSkuProduct"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <label for="" class="color-dark-gray font-weight-600"
            >Fecha Estimada</label
          >

          <b-form-datepicker
            class="text-medium bg-grey color-black"
            :min="minDate"
            :max="maxDate"
            :value="estimatedDate"
            v-on:input="$emit('update:estimatedDate', $event)"
            :date-disabled-fn="dateDisabled"
            locale="es"
            :date-format-options="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }"
          ></b-form-datepicker>
        </b-col>
      </b-row>
      <b-row class="padding-two-tb">
        <b-col cols="12">
          <label for="" class="color-dark-gray font-weight-600">Turno </label>
          <b-form-select
            class="bg-grey text-medium color-black"
            :disabled="isDisabled"
            :value="turn"
            @change="clearSelectedProvider()"
            v-on:input="$emit('update:turn', $event)"
            :options="optionsShip"
          ></b-form-select>
        </b-col>
      </b-row>
      <b-row class="padding-two-tb">
        <b-col cols="12">
          <label class="color-dark-gray font-weight-600">Proveedor</label>
          <b-input-group>
            <template v-slot:append>
              <b-input-group-text class="padding-all-none">
                <b-button
                  :disabled="isDisabled"
                  @click="searchProvider()"
                  class="bg-white border-none hidden-disabled color-dark-gray"
                  ><font-awesome-icon class="color-orange" icon="search"
                /></b-button>
              </b-input-group-text>
            </template>
            <b-form-input
              :disabled="isDisabled"
              v-model="providerName"
              class="
                border-right-none
                bg-grey
                disable-input
                text-medium
                color-black
              "
              size="md"
            >
            </b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="padding-two-tb">
        <b-col cols="12">
          <label for="" class="color-dark-gray font-weight-600"
            >Observación al proveedor
          </label>
          <b-form-textarea
            :disabled="isDisabled"
            :value="providerObservation"
            v-on:input="$emit('update:providerObservation', $event)"
            id="textarea-small"
            class="bg-grey text-medium color-black"
            size="sm"
          ></b-form-textarea>
        </b-col>
      </b-row>
      <b-row class="padding-two-tb">
        <b-col cols="6" class="section__filter_border">
          <b-button
            class="btn-transparent-orange border-none"
            v-if="!isDisabled"
            :disabled="isFieldsCompleted()"
            @click="isDisabled = !isDisabled"
          >
            GRABAR
          </b-button>
          <b-button
            @click="isDisabled = !isDisabled"
            class="btn-transparent-orange border-none"
            v-else
          >
            EDITAR
          </b-button>
        </b-col>
        <b-col cols="6">
          <b-button
            class="btn-transparent-red border-none"
            @click="$emit('update:isSelected', false)"
          >
            ELIMINAR
          </b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-col>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "DetailsSellerNote",

  data() {
  
    return {
      expressService:false,
      currentDate: moment()
        .add(1, "days")
        .format("YYYY-MM-DD"),
      optionsShip: [
        { value: null, text: "Seleccione una opción" },
        { value: "MORNING", text: "Mañana" },
        { value: "AFTERNOON", text: "Tarde" },
        { value: "ALL_DAY", text: "Durante el día" },
      ],
      isDisabled: false,
      timeout: null,
    };
  },
  props: {
    descriptionSkuProduct: {
      type: String,
    },
    descriptionSku: {
      type: String,
    },
    quantity: {
      type: Number,
    },
    turn: {
      type: String,
    },
    skuProduct: {
      type: String,
    },
    skuService: {
      type: String,
    },
    estimatedDate: {
      type: String,
    },
    restrictedDays: {
      type: Array,
    },
    providerName: {
      type: String,
    },
    providerObservation: {
      type: String,
    },
    storeCode: {
      type: Number,
    },
    rowIndex: {
      type: Number,
    },
    indexModal: {
      type: Number,
    },
    providerId: {
      type: Number,
    },
    isSelected: {
      type: Boolean,
    },
    maxLimit: {
      type: Number,
    },
    messageEstimation: {
      type: String,
    },
  },
  computed: {
    minDate(){
      if(this.expressService){
       return moment()
        .format("YYYY-MM-DD")
      }
      else{
       return moment()
        .add(1, "days")
        .format("YYYY-MM-DD")
      }
    },
    maxDate() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      if(this.expressService){
       return moment()
        .format("YYYY-MM-DD")
      }
      else{
        const maxDate = new Date(today);
      maxDate.setMonth(maxDate.getMonth() + 2);
      return maxDate;
      }
      
    },
    ...mapState("module", ["username","token"]),
  },

  created() {},
  beforeDestroy() {
    this.resetTimeout();
  },
  methods: {
    resetDate(){
      this.$emit('update:estimatedDate', "")
    },
    resetTimeout() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    },
    formatToNumber(val) {
      return parseInt(val);
    },
    clearSelectedProvider() {
      if (this.providerName.length) this.$emit("update:providerName", "");
      this.$emit("update:providerId", null);
    },
    isFieldsCompleted() {
      if (this.turn && this.estimatedDate && this.providerName) return false;
      return true;
    },
    dateDisabled(ymd, date) {
      const weekday = date.getDay();
      let isDisabled = false;
      this.restrictedDays.forEach((item) => {
        if (ymd === item) {
          isDisabled = true;
        }
      });
      return isDisabled || weekday === 0;
    },
    searchProducts() {
      this.resetTimeout();
      let self = this;
      this.timeout = setTimeout(function() {
        self.getSkuProduct();
      }, 3000);
    },
    async getSkuProduct() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_SERVICES_CORE_BASE +
            "/products/" +
            this.skuProduct,
            {
              headers: {
                  "Content-type": "application/json",
                  "Authorization": "Bearer "+ this.token
                }
            }
        );
        console.log(response);
        this.$emit("update:descriptionSkuProduct", response.data.description);
      } catch (error) {
        console.error(error);
      }
    },
    searchServices() {
      this.resetTimeout();
      let self = this;
      this.timeout = setTimeout(function() {
        self.getSkuService();
      }, 3000);
    },
    async getSkuService() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_SERVICES_CORE_BASE +
            "/services/" +
            this.skuService,
            {
              headers: {
                  "Content-type": "application/json",
                  "Authorization": "Bearer "+ this.token
                }
            }
        );
        console.log(response);
        this.$emit("update:descriptionSku", response.data.description);
      } catch (error) {
        console.error(error);
      }
    },
    async searchProvider() {
      try {
        this.$emit("update:showModalProvider", true);
        this.$emit("update:isBusyM", true);
        this.$emit("update:rowIndex", this.indexModal);
        let source = axios.CancelToken.source();
        this.$emit("update:request", {
          cancel: source.cancel,
          msg: "Loading...",
        });
        let parseSku = this.skuService.trim();
        let exp=this.expressService?1:0;
        let response = await axios.get(
          process.env.VUE_APP_ESTIMATIONS_BASE +
            "/estimations?serviceSku=" +
            parseSku +
            "&turn=" +
            this.turn +
            "&date=" +
            this.estimatedDate +
            "&storeCode=" +
            this.storeCode+
            "&express="+
            exp,
          // 517
          {
            headers: {
              client_id: process.env.VUE_APP_CLIENT_ID,
              access_token: process.env.VUE_APP_ACCESS_TOKEN,
            },
            cancelToken: source.token,
          }
        );
        this.$emit("update:optionsProvider", response.data.data);
      } catch (error) {
        if (error.response) {
          if (error.response.data.message) {
            this.$emit("update:messageEstimation", error.response.data.message);
          } else {
            this.$emit("update:messageEstimation", error.response.data);
          }
        }
      } finally {
        this.$emit("update:isBusyM", false);
      }
    },
  },
};
</script>
<style scoped>
.bg-grey.form-control:read-only {
  background: white !important;
  border-bottom: none !important;
}
.bg-grey.form-control:disabled {
  background: white !important;
  border-bottom: none !important;
}
.custom-select:disabled {
  background: white !important;
  border-bottom: none !important;
  color: #000000 !important;
}
.hidden-disabled.btn:disabled {
  display: none;
}
.disable-input {
  pointer-events: none;
}
</style>
